export const getChangeUrl = from => {
  if (from === 'Реальный') {
    return '/balance_code_to_deposit';
  }

  return '/balance_deposit_to_code';
};
